import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { AppRoutes, UserStateService } from '@core';

export const isAdminGuard: CanActivateFn = (): boolean | UrlTree => {
  const userState: UserStateService = inject(UserStateService);
  const router: Router = inject(Router);

  return userState.isAdmin() ? true : router.parseUrl(`/${AppRoutes.TODAY}`);
};
